export default {
  // 面包屑
  breadcrumb: {
    projectSettings: '项目设置',
    interviewSettings: '选考设置',
    interviewProcess: '选考流程',
    createProcess: '创建选考流程',
    editProcess: '编辑选考流程',
  },

  // 列表页
  pageTitle: '选考流程',
  searchPlaceholder: '搜索选考流程名称',
  createProcess: '创建选考流程',
  processName: '选考流程名称',
  employmentType: '雇佣形式',
  selectionProcess: '选考流程',
  processDescription: '选考流程说明',
  isEnabled: '是否启用',
  lastEditTime: '最近编辑时间',
  lastEditor: '最近编辑人',
  creator: '创建人',
  createTime: '创建时间',
  enabled: '已启用',
  disabled: '已停用',

  // 详情页
  createTitle: '创建选考流程',
  editTitle: '编辑选考流程',
  basicInfo: '基本信息',
  processNamePlaceholder: '请输入',
  employmentTypePlaceholder: '请选择',
  processDescriptionPlaceholder: '请输入',
  processFlow: '选考流程',

  // 选考环节
  resumeScreening: '简历筛选',
  interview: '面试',
  offer: '内定',
  onboarding: '入职',
  other: '其他',

  // 选考环节字段
  stageName: '选考环节名称',
  stageType: '选考环节类型',
  evaluationTemplate: '评价模板',
  addInterview: '添加面试',

  // 占位符
  stageNamePlaceholder: '请输入',
  stageTypePlaceholder: '请选择',
  evaluationTemplatePlaceholder: '请选择',

  // 评价模板选项（临时固定）
  defaultTemplate: '默认模板',
  technicalTemplate: '技术面试模板',
  hrTemplate: 'HR面试模板',

  // 雇佣形式选项
  fullTime: '正式员工',
  contract: '合同员工',

  // 验证消息
  processNameRequired: '请输入选考流程名称',
  employmentTypeRequired: '请选择雇佣形式',
  stageNameRequired: '请输入选考环节名称',
  stageTypeRequired: '请选择选考环节类型',
  evaluationTemplateRequired: '请选择评价模板',
  processNameDuplicate: '选考流程名称已存在',
  stageNameDuplicate: '选考环节名称已存在',

  // 删除确认
  deleteConfirmTitle: '确认删除选考流程',
  deleteConfirmContent: '删除后不可恢复，确认删除选考流程「{name}」吗？',
  deleteNotAllowedTitle: '确认删除选考流程',
  deleteNotAllowedContent: '存在职位使用此选考流程，暂不支持删除。',

  // 启用/停用确认
  enableConfirmTitle: '确认启用选考流程',
  enableConfirmContent: '启用后，新创建职位时可选择此选考流程。',
  disableConfirmTitle: '确认停用选考流程',
  disableConfirmContent: '停用后，新创建职位时不可选择此选考流程，已创建的职位不受影响。',

  // 启用状态说明
  enabledDescription: '已开启，新创建注册候选人时可选择此渠道来源',
  disabledDescription: '已关闭，新创建注册候选人时不可选择此渠道来源',

  // 空状态
  emptyStates: {
    noData: {
      title: '暂无选考流程',
      description: '请先创建选考流程',
    },
  },
  btnEnable: '启用',
  btnDisable: '停用',
};
